import { Link } from "react-router-dom";
import type { ContentItem } from "@/types/content";
import { formatDate } from "@/lib/content";

export default function AnalysisStrip({ items }: { items: ContentItem[] }) {
  if (items.length === 0) return null;
  return (
    <div className="flex gap-4 overflow-x-auto pb-2 hide-scrollbar">
      {items.map((item) => (
        <Link
          key={item.id}
          to={`/detail/${item.id}`}
          className="group flex w-[280px] shrink-0 cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:w-[320px]"
        >
          <div className="mb-3 flex items-center gap-2 text-xs">
            <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-0.5 font-medium text-secondary-800">
              <i className="ri-lightbulb-line" />
              {item.category}
            </span>
            <span className="text-foreground-400">{formatDate(item.date)}</span>
          </div>
          <h3 className="line-clamp-2 text-base font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
            {item.title}
          </h3>
          <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">
            {item.summary}
          </p>
          <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
            阅读解析
            <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
          </span>
        </Link>
      ))}
    </div>
  );
}